import { Directive } from "@angular/core";

@Directive({
    selector: '[t4AdditionalContent]',
    standalone: false
})
  export class ListAdditionalContentDirective {}
